<template>
    <div class="loading" v-if="show">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
    export default {
        name: "Loading",
        props: {
            show: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.loading{
    text-align: center;
    padding: 1rem;
}
.loading span {
    display: inline-block;
    width: 4px;
    height: 24px;
    background-color: #009688;
    border-radius: 3px;
    margin-right: 4px;
    animation: loading 1s ease infinite;
}
@keyframes loading {
    0%, 100% {
        transform: scaleY(1.0);
        background-color: #009688;
    }
    50% {
        transform: scaleY(1.2);
        background-color: #1E9FFF;
    }
}
.loading span:nth-child(2) {
    animation-delay: 0.2s;
}
.loading span:nth-child(3) {
     animation-delay: 0.4s;
 }
.loading span:nth-child(4) {
    animation-delay: 0.6s;
}
.loading span:nth-child(5) {
    animation-delay: 0.5s;
}
</style>